<template>
  <li>
    <router-link :to="coachDetailsLink" class="focus:outline-none">
      <div class="relative px-6 py-5 flex items-center space-x-3 hover:bg-gray-50 focus-within:ring-2 focus-within:ring-inset focus-within:ring-pink-500">
      <div class="flex-shrink-0">
        <img v-if="picUrl" class="h-10 w-10 rounded-full" :src="picUrl" alt="" />

        <span v-else class="inline-block h-10 w-10 rounded-full overflow-hidden bg-gray-100">
          <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
          </svg>
        </span>
      </div>
      <div class="flex-1 min-w-0">

          <!-- Extend touch target to entire panel -->
          <span class="absolute inset-0" aria-hidden="true" />
          <p class="text-sm font-medium text-gray-900">
            {{ fullName }}
          </p>
          <p class="text-sm text-gray-500 truncate">
            ${{ rate }}
          </p>
          <p class="text-sm text-gray-500 truncate">
            <span
                v-for="area in areas" :key="area"
                :class="`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-white mr-1 ${area}`">
                {{ area.toUpperCase() }}
            </span>
          </p>

      </div>
    </div>
    </router-link>
  </li>
</template>

<script>
export default {
  name: "CoachItem",
  props: ['coachId', 'firstName', 'lastName', 'picUrl', 'areas', 'rate'],
  //todo add computed properties for some fomratting and extra stuff
  computed: {
    fullName() {
      return this.firstName + ' ' + this.lastName;
    },
    coachContactLink() {
      return this.$route.path + '/' + this.coachId + '/contact' // /coaches/c1/contact
    },
    coachDetailsLink() {
      //console.log(this.$route.path);
      return '/coaches/' + this.coachId; // /coaches/c1
    },
  }
}
</script>
